// extracted by mini-css-extract-plugin
module.exports = {"spin":"DiscoveryFilter_spin__2pkNq","ScrollBars":"DiscoveryFilter_ScrollBars__15YEv"};